/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Form, Tabs, TabsProps } from "antd";
import { useForm } from "react-hook-form";

import { useEffect, useState } from "react";

import { useAppDispatch } from "../../../../../../config/hooks";
import GeneralTab from "./Tabs/general";
import LaborTab from "./Tabs/labor";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError, AxiosResponse } from "axios";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { RcFile } from "antd/es/upload";
import {
  createService,
  uploadUserImage,
} from "../../../../../CompanySettings/Services/ducks/services";
import { getServiceFormData } from "../../../../../CompanySettings/Services/ducks/actions";

interface FormValues {
  name: string;
  description: string;
  frequency: string;
  quantity_unit: string;
  take_off: string;
  subcontractors: string;
  category_ids: string[];
  production_rate: number;
  materials: { manager: string; use_rate: number; unit_order: string }[];
  equipment: string[];
}

interface PropsType {
  setLoading: (loading: boolean) => void;
  companyId: string;
  serviceLineId: string;
  parentId?: string;
  onClose: () => void;
}
interface materialDropDownType {
  label: string;
  options: { value: string; label: string; color?: string; type: string }[];
}
export default function AddServices(props: PropsType) {
  const { setLoading, companyId, serviceLineId, parentId, onClose } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const [serviceType, setServiceType] = useState("in_house");
  const [frequencyType, setFrequencyType] = useState("one_time");
  const [takeOff, isTakeOff] = useState(false);
  const [takeOffType, setTakeOffType] = useState("...");
  const [checklistFile, setChecklistFile] = useState<File | null>(null);
  const [addEquipment, setAddEquipment] = useState(false);
  const [unitHour, setUnitHour] = useState(true);
  const [combineDropDown, setCombineDropDown] = useState<
    materialDropDownType[]
  >([]);

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    const dummyArray: any[] = [];

    if (val?.materials?.length > 0) {
      val?.materials?.map((e: { manager: string }) => {
        combineDropDown?.forEach((resp) => {
          const filteredValue = resp?.options?.find(
            (opt) => opt?.value === e?.manager
          );
          if (filteredValue) {
            dummyArray.push(filteredValue);
          }
          return filteredValue;
        });

        return true;
      });
    }

    const materialsPayload = dummyArray?.map((item) => {
      // Create the base object for the payload item
      const payloadItem = {
        material_type: item.type, // Use the 'type' property from your input item
        use_rate:
          val?.materials?.find((e) => e?.manager === item?.value)?.use_rate ??
          0, // Get use_rate from the input item
        unit_order:
          val?.materials?.find((e) => e?.manager === item?.value)?.unit_order ??
          "material_unit_per_measurement_unit", // Get unit_order from the input item
        material_category_id: undefined,
        material_id: undefined,
      };

      // Add the appropriate ID based on the item's type
      if (item.type === "category") {
        payloadItem.material_category_id = item.value; // Use the item's value as the category ID
      } else if (item.type === "material") {
        payloadItem.material_id = item.value; // Use the item's value as the material ID
      }

      // Return the transformed object for this item
      return payloadItem;
    });

    const payload = {
      name: val?.name,
      service_line_id: serviceLineId,
      company_id: companyId,
      parent_id: parentId ?? undefined,
      // type: type,
      description: val?.description,
      service_provision_type: serviceType,
      // frequency:
      //   frequencyType === "one_time"
      //     ? "one_time"
      //     : type === "subservice"
      //     ? "recurring"
      //     : val?.frequency,
      takeoff_id: takeOff ? val?.take_off : undefined,
      unit_id: takeOff ? undefined : val?.quantity_unit,
      production_rate:
        serviceType === "in_house" ? val?.production_rate : undefined,
      production_rate_type: unitHour ? "unit_per_hour" : "hour_per_unit",
      category_ids:
        val?.category_ids?.length > 0 ? val?.category_ids : undefined,
      materials: serviceType === "in_house" ? materialsPayload : undefined,
      equipments: serviceType === "in_house" ? val?.equipment : undefined,
    };

    createService(payload)
      .then((res: AxiosResponse) => {
        if (checklistFile && res && res?.data?.id) {
          uploadUserImage({
            owner_id: res?.data?.id,
            image: checklistFile as File | RcFile,
            image_type: "service_image",
          })
            .then(() => {
              setLoading(false);
              navigate(
                `/company-settings/service-lines/${serviceLineId}/${companyId}`
              );
              SuccessMessage(`${parentId ? "Subservice" : "Service"} created`);
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        } else {
          setLoading(false);
          navigate(
            `/company-settings/service-lines/${serviceLineId}/${companyId}`
          );
          SuccessMessage(`${parentId ? "Subservice" : "Service"} created`);
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const onChange = (key: string) => {
    setActiveTab(key);
  };

  const nameValue = watch("name");
  const unitValue = watch("quantity_unit");
  const takeOffValue = watch("take_off");

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "General details",
      children: (
        <GeneralTab
          control={control}
          errors={errors}
          setLoading={setLoading}
          serviceType={serviceType}
          setValue={setValue}
          frequencyType={frequencyType}
          takeOff={takeOff}
          type={""}
          isTakeOff={isTakeOff}
          setServiceType={setServiceType}
          setFrequencyType={setFrequencyType}
          checklistFile={checklistFile}
          setChecklistFile={setChecklistFile}
          setTakeOffType={setTakeOffType}
          frequencyTypeData="as"
        />
      ),
    },
    {
      key: "2",
      label: "simple",
      disabled: !nameValue || (!unitValue && !takeOffValue),
      children: (
        <LaborTab
          control={control}
          errors={errors}
          type={"type"}
          setLoading={setLoading}
          serviceType={serviceType}
          companyId={companyId}
          combineDropDown={combineDropDown}
          addEquipment={addEquipment}
          setCombineDropDown={setCombineDropDown}
          setAddEquipment={setAddEquipment}
          takeOffType={takeOffType}
          watch={watch}
          unitHour={unitHour}
          setUnitHour={setUnitHour}
          setValue={setValue}
        />
      ),
    },
  ];

  useEffect(() => {
    if (companyId) {
      dispatch(getServiceFormData(companyId));
    }
  }, [companyId, dispatch]);

  return (
    <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
      <Col style={{ width: "672px", paddingBottom: 85 }}>
        <div className="title">
          <h2 style={{ marginBottom: "4px" }}>
            Create {parentId ? "subservice" : "service"}{" "}
          </h2>
          <p style={{ fontSize: "16px" }}>
            A service becomes a work order, which your team schedules and
            completes.
          </p>
        </div>

        <div className="service_tabs">
          <Tabs
            activeKey={activeTab}
            items={items}
            onChange={onChange}
            className="tabsParent"
          />
          {/* <div className="service_tabs_item active">General details</div>
          <div className="service_tabs_item">Labor, Materials, Equipment</div> */}
        </div>
      </Col>
      <div className="fixed_btm_card">
        <Card>
          <div className="centered">
            <Button
              htmlType="button"
              className="outlined-btn"
              onClick={() => onClose()}
            >
              Cancel
            </Button>
            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                htmlType="submit"
                type="primary"
                className="mint-btn"
                // onClick={() => setCurrent && setCurrent(1)}
              >
                {parentId
                  ? activeTab === "2"
                    ? "Create subservice"
                    : "Continue"
                  : activeTab === "2"
                  ? "Create service"
                  : "Continue"}
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Form>
  );
}
